<!-- side-bar single product slider start -->
<div class="theme-card">
    <h5 class="title-border">{{'selling.new_product' | translate}}</h5>
    <!-- <ngx-slick-carousel class="offer-slider" #slickModal="slick-carousel">
        <div ngxSlickItem *ngFor="let slide of productSlides">
            <div class="media" *ngFor="let product of slide">
                <div class="mb-3" [routerLink]="['/home/product/', product.resourceId]">
                    <h4 class="product-title no-w">{{ product.title }}</h4>
                    <div class="product-description">{{ product.startDateTime | localizedDate }}</div>
                    <div class="product-description">{{ product.place }}  {{ product.address }}</div>
                </div>
            </div>
        </div>
    </ngx-slick-carousel> -->
</div>
<!-- side-bar single product slider end -->
